import { PRIORITY } from "@/lib/status";
import { fmtMin } from "@/lib/format";
import { Panel } from "@/components/common/Panel";
import { DataTable } from "@/components/common/DataTable";
import { StatusBadge } from "@/components/common/StatusBadge";
import { CheckCircle2 } from "lucide-react";

const columns = [
  { key: "priorite", header: "Priorité", render: (r) => <StatusBadge config={PRIORITY} code={r.priorite} /> },
  { key: "ligne", header: "Ligne", cellClassName: "font-semibold" },
  { key: "etat", header: "État" },
  { key: "cause", header: "Cause", cellClassName: "text-muted-foreground max-w-[220px] truncate" },
  { key: "duree_min", header: "Durée", align: "right", render: (r) => fmtMin(r.duree_min) },
  { key: "impact_trs_pts", header: "Impact TRS", align: "right", render: (r) => (r.impact_trs_pts != null ? `−${r.impact_trs_pts} pts` : "—") },
  { key: "responsable", header: "Responsable", render: (r) => r.responsable || "—" },
  { key: "action", header: "Action recommandée", cellClassName: "text-muted-foreground whitespace-normal min-w-[260px]" },
];

export const InterventionsPanel = ({ interventions }) => (
  <Panel title="Interventions requises" subtitle={`${interventions.length} en attente`} testId="interventions-panel">
    {interventions.length === 0
      ? <div className="p-6 flex items-center gap-2 text-xs text-muted-foreground"><CheckCircle2 className="h-4 w-4 text-emerald-400" />Aucune intervention requise — aucun déclencheur actif (arrêt, sous-performance, rejets, retard).</div>
      : <DataTable testId="interventions-table" columns={columns} rows={interventions} rowKey={(r, i) => `${r.ligne}-${r.etat}`} />}
  </Panel>
);
